// Avisos de "Historial de Pagos": lo que cambio en las ordenes del alumno sin que lo hiciera el cajero (los manda
// wMultipagosObtenerPendientes.php en "avisos"). Sirven para que el cajero entienda por que una orden ya no esta
// pendiente, o cual usar, sin que nadie le tenga que explicar el cambio.

const dinero = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const ddmm = (iso) => (iso ? `${String(iso).substring(8, 10)}/${String(iso).substring(5, 7)}` : "");
const orden = (a) => `la orden ${a.orden}${a.folio ? ` (folio ${a.folio})` : ""}`;

export function textoDeAviso(a) {
  switch (a.tipo) {
    case "VALIDACION_BANCO":
      return `${orden(a)} por ${dinero(a.importe)} ya está PAGADA: el sistema la validó${a.fecha ? ` el ${ddmm(a.fecha)}` : ""} con el archivo del banco${a.fecha_pago ? ` (el alumno pagó el ${ddmm(a.fecha_pago)})` : ""}. Aparece abajo como PAGADA; no la cobres otra vez.`;
    case "REASIGNAR_ORIGEN":
      return `El pago que estaba en ${orden(a)} se pasó a la orden de otro alumno${a.fecha ? ` el ${ddmm(a.fecha)}` : ""}, porque era de él. Esta orden regresó a PENDIENTE: el alumno todavía la debe.`;
    case "REASIGNAR_DESTINO":
      return `${orden(a)} se validó${a.fecha ? ` el ${ddmm(a.fecha)}` : ""} con un pago que se había registrado por error en la orden de otro alumno. Aparece abajo como PAGADA.`;
    case "FICHA_REPETIDA": {
      const usar = String(a.nota || "").split(": ").slice(1).join(": ");
      return `La ficha con folio ${a.folio} (orden ${a.orden}) se canceló porque estaba repetida${usar ? `; ${usar}` : ""}. Si el alumno trae esa ficha, valida la otra orden.`;
    }
    default:
      return "";
  }
}

// Mayuscula inicial (los textos empiezan con "la orden ...")
export const avisosParaMostrar = (avisos = []) => (Array.isArray(avisos) ? avisos : [])
  .map((a) => textoDeAviso(a))
  .filter(Boolean)
  .map((t) => t.charAt(0).toUpperCase() + t.slice(1));
